export default __webpack_public_path__ + "static/media/close-black.cce11fbb.svg";